// Popular Indian cities for the all-India searchable selector.
// Users can also type ANY city not on this list — the selector allows free-text exploration.
export const INDIAN_CITIES = [
  { name: "Etah", state: "Uttar Pradesh" },
  { name: "Agra", state: "Uttar Pradesh" },
  { name: "Firozabad", state: "Uttar Pradesh" },
  { name: "Aligarh", state: "Uttar Pradesh" },
  { name: "Tundla", state: "Uttar Pradesh" },
  { name: "Mainpuri", state: "Uttar Pradesh" },
  { name: "Sambhal", state: "Uttar Pradesh" },
  { name: "Moradabad", state: "Uttar Pradesh" },
  { name: "Kasganj", state: "Uttar Pradesh" },
  { name: "Hathras", state: "Uttar Pradesh" },
  { name: "Mathura", state: "Uttar Pradesh" },
  { name: "Kanpur", state: "Uttar Pradesh" },
  { name: "Lucknow", state: "Uttar Pradesh" },
  { name: "Varanasi", state: "Uttar Pradesh" },
  { name: "Prayagraj", state: "Uttar Pradesh" },
  { name: "Meerut", state: "Uttar Pradesh" },
  { name: "Ghaziabad", state: "Uttar Pradesh" },
  { name: "Noida", state: "Uttar Pradesh" },
  { name: "Bareilly", state: "Uttar Pradesh" },
  { name: "Gorakhpur", state: "Uttar Pradesh" },
  { name: "Jhansi", state: "Uttar Pradesh" },
  { name: "Saharanpur", state: "Uttar Pradesh" },
  { name: "Muzaffarnagar", state: "Uttar Pradesh" },
  { name: "Ayodhya", state: "Uttar Pradesh" },
  { name: "Bulandshahr", state: "Uttar Pradesh" },
  { name: "Rae Bareli", state: "Uttar Pradesh" },
  { name: "Sitapur", state: "Uttar Pradesh" },
  { name: "Etawah", state: "Uttar Pradesh" },
  { name: "New Delhi", state: "Delhi" },
  { name: "Delhi", state: "Delhi" },
  { name: "Gurugram", state: "Haryana" },
  { name: "Faridabad", state: "Haryana" },
  { name: "Panipat", state: "Haryana" },
  { name: "Ambala", state: "Haryana" },
  { name: "Karnal", state: "Haryana" },
  { name: "Hisar", state: "Haryana" },
  { name: "Rohtak", state: "Haryana" },
  { name: "Chandigarh", state: "Chandigarh" },
  { name: "Ludhiana", state: "Punjab" },
  { name: "Amritsar", state: "Punjab" },
  { name: "Jalandhar", state: "Punjab" },
  { name: "Patiala", state: "Punjab" },
  { name: "Bathinda", state: "Punjab" },
  { name: "Mohali", state: "Punjab" },
  { name: "Mumbai", state: "Maharashtra" },
  { name: "Pune", state: "Maharashtra" },
  { name: "Nagpur", state: "Maharashtra" },
  { name: "Nashik", state: "Maharashtra" },
  { name: "Thane", state: "Maharashtra" },
  { name: "Aurangabad", state: "Maharashtra" },
  { name: "Solapur", state: "Maharashtra" },
  { name: "Kolhapur", state: "Maharashtra" },
  { name: "Navi Mumbai", state: "Maharashtra" },
  { name: "Bengaluru", state: "Karnataka" },
  { name: "Mysuru", state: "Karnataka" },
  { name: "Hubballi", state: "Karnataka" },
  { name: "Mangaluru", state: "Karnataka" },
  { name: "Belagavi", state: "Karnataka" },
  { name: "Chennai", state: "Tamil Nadu" },
  { name: "Coimbatore", state: "Tamil Nadu" },
  { name: "Madurai", state: "Tamil Nadu" },
  { name: "Tiruchirappalli", state: "Tamil Nadu" },
  { name: "Salem", state: "Tamil Nadu" },
  { name: "Tirunelveli", state: "Tamil Nadu" },
  { name: "Hyderabad", state: "Telangana" },
  { name: "Warangal", state: "Telangana" },
  { name: "Nizamabad", state: "Telangana" },
  { name: "Visakhapatnam", state: "Andhra Pradesh" },
  { name: "Vijayawada", state: "Andhra Pradesh" },
  { name: "Guntur", state: "Andhra Pradesh" },
  { name: "Tirupati", state: "Andhra Pradesh" },
  { name: "Nellore", state: "Andhra Pradesh" },
  { name: "Kochi", state: "Kerala" },
  { name: "Thiruvananthapuram", state: "Kerala" },
  { name: "Kozhikode", state: "Kerala" },
  { name: "Thrissur", state: "Kerala" },
  { name: "Kollam", state: "Kerala" },
  { name: "Ahmedabad", state: "Gujarat" },
  { name: "Surat", state: "Gujarat" },
  { name: "Vadodara", state: "Gujarat" },
  { name: "Rajkot", state: "Gujarat" },
  { name: "Bhavnagar", state: "Gujarat" },
  { name: "Jamnagar", state: "Gujarat" },
  { name: "Gandhinagar", state: "Gujarat" },
  { name: "Jaipur", state: "Rajasthan" },
  { name: "Jodhpur", state: "Rajasthan" },
  { name: "Udaipur", state: "Rajasthan" },
  { name: "Kota", state: "Rajasthan" },
  { name: "Ajmer", state: "Rajasthan" },
  { name: "Bikaner", state: "Rajasthan" },
  { name: "Alwar", state: "Rajasthan" },
  { name: "Bhopal", state: "Madhya Pradesh" },
  { name: "Indore", state: "Madhya Pradesh" },
  { name: "Jabalpur", state: "Madhya Pradesh" },
  { name: "Gwalior", state: "Madhya Pradesh" },
  { name: "Ujjain", state: "Madhya Pradesh" },
  { name: "Sagar", state: "Madhya Pradesh" },
  { name: "Patna", state: "Bihar" },
  { name: "Gaya", state: "Bihar" },
  { name: "Bhagalpur", state: "Bihar" },
  { name: "Muzaffarpur", state: "Bihar" },
  { name: "Darbhanga", state: "Bihar" },
  { name: "Kolkata", state: "West Bengal" },
  { name: "Howrah", state: "West Bengal" },
  { name: "Durgapur", state: "West Bengal" },
  { name: "Siliguri", state: "West Bengal" },
  { name: "Asansol", state: "West Bengal" },
  { name: "Bhubaneswar", state: "Odisha" },
  { name: "Cuttack", state: "Odisha" },
  { name: "Rourkela", state: "Odisha" },
  { name: "Puri", state: "Odisha" },
  { name: "Ranchi", state: "Jharkhand" },
  { name: "Jamshedpur", state: "Jharkhand" },
  { name: "Dhanbad", state: "Jharkhand" },
  { name: "Bokaro", state: "Jharkhand" },
  { name: "Raipur", state: "Chhattisgarh" },
  { name: "Bhilai", state: "Chhattisgarh" },
  { name: "Bilaspur", state: "Chhattisgarh" },
  { name: "Dehradun", state: "Uttarakhand" },
  { name: "Haridwar", state: "Uttarakhand" },
  { name: "Rishikesh", state: "Uttarakhand" },
  { name: "Haldwani", state: "Uttarakhand" },
  { name: "Nainital", state: "Uttarakhand" },
  { name: "Shimla", state: "Himachal Pradesh" },
  { name: "Manali", state: "Himachal Pradesh" },
  { name: "Dharamshala", state: "Himachal Pradesh" },
  { name: "Srinagar", state: "Jammu & Kashmir" },
  { name: "Jammu", state: "Jammu & Kashmir" },
  { name: "Guwahati", state: "Assam" },
  { name: "Dibrugarh", state: "Assam" },
  { name: "Silchar", state: "Assam" },
  { name: "Imphal", state: "Manipur" },
  { name: "Shillong", state: "Meghalaya" },
  { name: "Agartala", state: "Tripura" },
  { name: "Aizawl", state: "Mizoram" },
  { name: "Kohima", state: "Nagaland" },
  { name: "Itanagar", state: "Arunachal Pradesh" },
  { name: "Gangtok", state: "Sikkim" },
  { name: "Panaji", state: "Goa" },
  { name: "Margao", state: "Goa" },
  { name: "Puducherry", state: "Puducherry" },
];
